const Availability = Object.freeze({
  AVAILABLE: 'available',
  UNAVAILABLE: 'unavailable',
  LOADING: 'loading',
  NOT_CHECKED: 'not_checked',
} as const);

export type Availability = (typeof Availability)[keyof typeof Availability];

export default Availability;
